import { useMemo } from 'react';
import { Box, Paper, TextField, Typography, Autocomplete, Chip } from '@mui/material';
import { ClientCombineFormProps } from '../utils/DataTypes';

const ClientCombineForm = ({
  primaryClient,
  allClients,
  selectedCombineClients,
  onCombineClientsChange,
}: ClientCombineFormProps) => {
  const filteredClientOptions = useMemo(() => {
    return allClients.filter((client) => client.client_number !== primaryClient.client_number);
  }, [allClients, primaryClient]);

  return (
    <Box sx={{ mt: 4 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Client Bill Combine Details
        </Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, mb: 3 }}>
          <TextField label="Primary Billing Client" value={primaryClient.client_name} variant="standard" disabled />
          <TextField label="Primary Client Number" value={primaryClient.client_number} variant="standard" disabled />
        </Box>

        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
          Clients to Combine (Subsidiaries)
        </Typography>

        <Autocomplete
          multiple
          filterSelectedOptions
          options={filteredClientOptions}
          value={selectedCombineClients}
          onChange={(event, newValue) => onCombineClientsChange(newValue)}
          getOptionLabel={(option) => `${option.client_name} (${option.client_number})`}
          isOptionEqualToValue={(option, value) => option.client_number === value.client_number}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Add Client(s) to Combine Bill"
              placeholder="Search by name or number..."
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const { key, ...tagProps } = getTagProps({ index });
              return (
                <Chip
                  key={key}
                  variant="outlined"
                  label={`${option.client_name} (${option.client_number})`}
                  {...tagProps}
                />
              );
            })
          }
          sx={{ mb: 2 }}
        />
      </Paper>
    </Box>
  );
};

export default ClientCombineForm;
